export default __webpack_public_path__ + "static/media/SING.b399e0ea.png";